import React, { useEffect, useState } from "react";
// import TopBar from "./TopBar";
import { Link, useLocation } from "react-router-dom";
import { IMAGES } from "../../assets/img/ImageIndex";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const location = useLocation();

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  // Close mobile menu automatically on route change
  useEffect(() => {
    setShowOffcanvas(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  return (
    <header id="masthead">
      {/* <TopBar /> */}
      <section data-id="1c2bf7b" data-element_type="section">
        <nav
          className={`navbar navbar-expand-lg ptb-10 nav-bg-2 ${
            scrolled ? "is-sticky" : ""
          }`}
          id="navbar"
        >
          <div className="container-fluid mw-1380">
            <Link to={"/" } className="navbar-brand">
              <img className="black-logo" src={IMAGES.logo} alt="Ralo" />
              <img className="m-logo" src={IMAGES.logo} alt="Ralo" />
            </Link>

            <Link
              className="navbar-toggler"
              onClick={toggleOffcanvas}
              role="button"
              aria-controls="navbarOffcanvas"
            >
              <span className="burger-menu">
                <span className="top-bar"></span>
                <span className="middle-bar"></span>
                <span className="bottom-bar"></span>
              </span>
            </Link>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul id="menu-primary-menu" className="navbar-nav m-auto">
                <li className="menu-item nav-item">
                  <Link
                    title="Home"
                    to={"/"}
                    className="nav-link"
                  >
                    Home
                  </Link>
                </li>

                <li className="menu-item nav-item">
                  <Link
                    title="Loan Program"
                    to={"/loan-program"}
                    className="nav-link"
                  >
                    Loan Program
                  </Link>
                </li>

                <li className="menu-item nav-item">
                  <Link title="Blog" to={"/blog"} className="nav-link">
                    Blog
                  </Link>
                </li>

                <li className="menu-item nav-item">
                  <Link
                    title="About Us"
                    to={"/about-us"}
                    className="nav-link"
                  >
                    About Us
                  </Link>
                </li>

                <li className="menu-item nav-item">
                  <Link title="Contact Us" to={"/contact-us"} className="nav-link">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <ul className="others-options ps-0 mb-0 list-unstyled justify-content-end">
              <li>
                <Link
                  to={"https://app.envocapital.com"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary elementor-repeater-item-c252f5b"
                >
                  Apply Now
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        {/* MOBILE NAVBAR */}
        <div
          className={`mobile-navbar offcanvas offcanvas-end border-0 ${
            showOffcanvas ? "show" : ""
          }`}
          data-bs-backdrop="static"
          tabIndex={-1}
          id="navbarOffcanvas"
        >
          <div className="offcanvas-header">
            <Link
              className="logo d-inline-block"
              to={"/"}
              style={{ maxWidth: 180 }}
            >
              <img src={IMAGES.logo} alt="Ralo" />
            </Link>

            <button
              type="button"
              className="close-btn bg-transparent position-relative lh-1 p-0 border-0"
              onClick={toggleOffcanvas}
              aria-label="Close"
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>

          <div className="offcanvas-body">
            <ul id="menu-primary-menu-1" className="responsive-menu mobile-menu">
              <li className="menu-item">
                <Link to={"/"}>Home</Link>
              </li>

              <li className="menu-item">
                <Link to={"/loan-program"}>Loan Program</Link>
              </li>

               <li className="menu-item">
                <Link to={"/blog"}>Blog</Link>
              </li>

              <li className="menu-item">
                <Link to={"/about-us"}>About Us</Link>
              </li>

              <li className="menu-item">
                <Link to={"/contact-us"}>Contact Us</Link>
              </li>

            </ul>
          </div>
        </div>

        {/* BACKDROP */}
        {showOffcanvas && (
          <div
            className="offcanvas-backdrop fade show"
            onClick={toggleOffcanvas}
          ></div>
        )}
      </section>
    </header>
  );
};

export default Header;
